<div class="dropdown language-switcher d-inline-block" [class.active]="classApplied2">
  <button class="dropdown-toggle" type="button" (click)="toggleClass2()" style="color: white;">
      <img [src]="language.flag" class="shadow" alt="image">
      <span>{{ language.name }} <i class='bx bx-chevron-down'></i></span>
  </button>
  <div class="dropdown-menu">
      <a *ngFor="let language of languages" href="javascript:;" class="dropdown-item d-flex align-items-center"
         (click)="setLanguageWithRefresh(language.lang)">
          <img [src]="language.flag" class="shadow-sm" alt="flag">
          <span>{{ language.name }}</span>
      </a>
  </div>
</div>